export enum BoardViewIdsEnum {
  MY_DISPUTES = 'my-disputes',
  OPEN_DISPUTES = 'open-disputes',
  HISTORICAL = 'historical-disputes',
}
